/**************************************************
 * Nombre:       Formacion_Centro
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_oficinas.png'
import logo from '../../../Recursos/logo_blanco.svg'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {irUrl} from "../../../Utilidades/irUrl";

const Formacion_Centro = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `linear-gradient(180deg, rgba(48, 51, 118, 0.85) 0%, rgba(48, 51, 118, 0.85) 100%), url(${fondo})`,
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', py: 10}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <img src={logo} width={350} height={'auto'}/>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 6}}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                                <Typography sx={{fontWeight: 300, textAlign: 'justify'}}>
                                    Somos Centro de Conciliación de naturaleza privada autorizada por el Ministerio
                                    de Justicia y Derecho mediante la Resolución 1025 del 10 de Mayo del 2017, Estamos a
                                    la
                                    vanguardia de lo que exige el Decreto 0042 del 21 de enero del 2026 del Ministerio
                                    de Justicia y del Derecho, manteniendo nuestra misión de certificar a profesionales
                                    y estudiantes no solo como conciliadores sino como agentes constructores de paz.
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 8}}>
                                {item.pdf &&
                                    <Button
                                        onClick={() => irUrl(item.pdf)}
                                        variant={'outlined'} color={'info'}>Descargar Documento Completo</Button>
                                }
                            </Grid>

                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Formacion_Centro  